import { Media } from "./media.interfaces";

interface Receipt {
    dateAdded: Date;
    file?: Media | null;
    sha1: string;
    date?: Date | null;
    vender?: string;
    lineItems?: string[];
    currency?: string;
    amount?: string;
    transactionID: string | null;
    deleted?: boolean;
    missingFile?: boolean;
    note?: string | null;
    chatGPTProcessedAt?: Date | null;
    matchedTransactionAmount?: number | null;
    linkedReceiptTotalAmount?: number | null;
    linkedReceiptCount?: number | null;
    linkedReceiptAmountsComplete?: boolean | null;
}

enum ReceiptSort {
    SORTED,
    UNSORTED,
    DELETED
}

export { Receipt, ReceiptSort }
